<template>
  <div>
    <div class="all">
      <div class="HomeInput">
        <Homseach />
      </div>
      <div class="EmptyState_a">
        <p>Search Result</p>
        <EmptyState />
      </div>
    </div>
  </div>
</template>

<script>
import EmptyState from "../EmptyState/EmptyState.vue";
// import HomeInput from "../Home/Home_input.vue";
import Homseach from "@/components/pc/serch.vue";
export default {
  components: {
    EmptyState,
    Homseach,
  },
};
</script>

<style lang="less" scoped>
.all {
  width: 100%;
  height: 100%;
  background-color: #13161b;
  padding-bottom: 40px;
  .HomeInput {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
  }
  .EmptyState_a {
    width: 1200px;
    background: #000;
    border-radius: 16px 16px 16px 16px;
    margin: 0 auto;
    p {
      padding: 20px 0 0 20px;
      font-size: 16px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
</style>